<template>
  <div>
    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      ref="batchCheckingWindow"
      :visible.sync="batchCheckingWindow.visible"
      :allow-partial-check-pass="batchCheckingWindow.allowPartialCheckPass"
      :lob="job.lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />
    <!--批量审核-->
    <check-dialog
      v-if="batchAuditDialog.visible"
      ref="batchAuditDialog"
      :page-date="batchAuditDialog.adjustPageDate"
      :show-page-date="true"
      :visible.sync="batchAuditDialog.visible"
      :edit-approval-date="editApprovalDate"
      :is-editable="batchAuditDialog.isEditable"
      :po-no="batchAuditDialog.isEditable ? '' : batchAuditDialog.poNo"
      @confirm="batchAuditConfirmCB"
      @returnDatePage="pageDate=>{batchAuditDialog.adjustPageDate=pageDate}"
    />
  </div>
</template>

<script>
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { generateInstructionRecord } from '@/api/sysManage/baseConfig/instruction'
import { cache } from '@/utils/cacheManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { checkChargeStateVerify, batchPreCommit, batchCommit } from '@/api/seaExport/seaExportJob'
import { batchManagerCommit } from '@/api/booking/job'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import { APPLICATION_DIMENSION_JOB_CHARGE, Job_CHARGE } from '@/class/cargo/model/parameters/WorkflowConstants'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { Assert } from '@/utils/validate'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import { jobAccountVerify, jobSingleAccountVerify } from '@/api/clearing/financeManage'
import { sendHecMessageByFinance } from '@/api/clearing/charge'
import * as ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import checkDialog from '@/views/cargo/v0/Clearing/components/financeManage/checkDialog'

const PRE_COMMIT_STATE = '预提交'
const COMMIT_STATE = '提交'
const MANAGER_COMMIT_STATE = '主管提交'
const VERIFY_STATE = '审核'

export default {
  name: 'UpdateJobStateWindow',
  components: { BatchCheckingWindow, checkDialog },
  data() {
    return {
      isSop: false,
      tenantInstruction: {
        uuid: '',
        platformInstructionCode: '',
        allowMultipleOperations: false
      },
      jobState: '',
      jobs: [],
      job: {},
      useOrderCenterMode: false,
      ticketsMustBeVoted: false,
      checkApChargeVerify: false,
      useCheckRule: false,
      allowPartialCheckPass: false,
      jobAndChargeSubmitterAndAuditorCanNotSame: false, // 业务和者费用的提交人与审核人不可以相同
      isAuditByJobState: false, // 审核方式
      editApprovalDate: false, // 是否允许编辑审核日期
      allSubmitFcl: false, // 是否允许全部提交
      openHecConfig: false,
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        allowPartialCheckPass: false,
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      batchAuditDialog: {
        visible: false,
        adjustPageDate: new Date(), // 审核 记录用户上次选择的时间
        isEditable: false,
        poNo: ''
      }
    }
  },
  computed: {
    location() {
      switch (this.job.lob) {
        case 'SE':
          return SystemConstants.LOG_SE_SEA_BOOKING.code
        case 'SI':
          return SystemConstants.LOG_SI_SEA_BOOKING.code
        case 'AE':
          return SystemConstants.LOG_AE_AIR_BOOKING.code
        case 'AI':
          return SystemConstants.LOG_AI_AIR_BOOKING.code
        case 'RE':
        case 'RI':
          return SystemConstants.LOG_RE_RAILWAY_BOOKING.code
      }
      return ''
    }
  },
  methods: {
    // SOP面板使用
    onShowOfSOP(sopInstruction, jobs) {
      this.isSop = true
      this.tenantInstruction.uuid = sopInstruction.uuid
      this.tenantInstruction.platformInstructionCode = sopInstruction.platformInstructionCode
      this.tenantInstruction.allowMultipleOperations = sopInstruction.allowMultipleOperations || false
      if (sopInstruction.instructionParamJson) {
        this.jobState = sopInstruction.instructionParamJson.jobstate || ''
      } else {
        this.jobState = ''
      }
      this.jobs = jobs
      this.job = jobs[0]
      this.startProcess()
    },
    // 开始处理
    startProcess() {
      this.useOrderCenterMode = Number(cache.config.get('useOrderCenterMode')) === 1
      this.ticketsMustBeVoted = Number(cache.config.get('TicketsMustBeVoted')) === 1
      this.checkApChargeVerify = Number(cache.config.get('PreCommitJobCheckApChargeStateVerify')) === 1
      this.useCheckRule = Number(cache.config.get('useCheckRule')) === 1
      this.allowPartialCheckPass = Number(cache.config.get('allowPartialCheckPass')) === 1
      this.jobAndChargeSubmitterAndAuditorCanNotSame = Number(cache.config.get('JobAndChargeSubmitterAndAuditorCanNotSame')) === 1
      this.isAuditByJobState = Number(cache.config.get('isAuditByJobState')) === 1
      this.editApprovalDate = Number(cache.config.get('isAllowEditApprovalDate')) === 1
      this.allSubmitFcl = Boolean(cache.config.get('AllSubmitFcl'))
      this.openHecConfig = Number(cache.config.get('openHecConfig')) === 1
      switch (this.jobState) {
        case PRE_COMMIT_STATE:
          this.toBatchPreSubmit()
          break
        case COMMIT_STATE:
          this.toBatchSubmit()
          break
        case MANAGER_COMMIT_STATE:
          this.toBatchManagerSubmission()
          break
        case VERIFY_STATE:
          this.batchAuditClickHandler()
          break
        default:
          break
      }
    },
    // 批量预提交
    toBatchPreSubmit() {
      const jobKeys = []
      for (const j of this.jobs) {
        if (this.isCooperate(j.cooperateStatus)) {
          this.$message.warning('[' + j.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (Number(j.jobState) !== Number(SystemConstants.OPERATING)) {
          this.$message.warning(this.$t('Message.BulkSubmissionOfWrittenPreSubmissionsOnlyList'))
          return
        }
        if (!j.masterFlag && !j.lclMasterUuid && (j.containerLoadType === 'LCL' || j.containerLoadType === 'BC') && this.ticketsMustBeVoted) {
          this.$message.warning(this.$t('Message.TicketsMustBeVoted'))
          return
        }
        jobKeys.push(j.uuid)
      }
      // 检查应付费用是否全部审核
      checkChargeStateVerify(jobKeys).then(res => this.checkChargeStateVerifyResult(res))
    },
    // 是否协作业务
    isCooperate(cooperateStatus) {
      if (cooperateStatus !== -1 && this.useOrderCenterMode) {
        return true
      }
      return false
    },
    // 检查应付费用是否全部审核
    async checkChargeStateVerifyResult(res) {
      const result = res.data
      if (this.checkApChargeVerify && result === 0) {
        this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
        return
      }
      const officeId = this.$store.getters.currentOfficeId
      const jobKeys = Array.from(this.jobs, p => p.uuid)
      if (jobKeys.length > 0) {
        const checkNode = CheckRuleConstants.NODE_PRE_COMMIT.code
        if (this.useCheckRule) {
          this.batchCheckingWindow.jobs = this.jobs // 回调中使用
          if (this.allowPartialCheckPass) {
            const callBack = this.batchPreCommitCall || null
            this.checkingManager(rows, checkNode, callBack, null, true)
          } else {
            const callBack = this.batchPreCommitCall || null
            this.checkingManager(this.jobs, checkNode, callBack, null, false)
          }
        } else {
          this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + jobKeys.length + this.$t('SeaExport.VotesPreSubmission'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {
            batchPreCommit({ jobKeys, officeId, location: this.location }).then(res => this.handlerPreCommitResult(res))
          }).catch(() => {})
        }
      }
    },
    // 批量预提交回调
    batchPreCommitCall() {
      let jobKeys = []
      if (!this.allowPartialCheckPass) {
        const jobs = this.batchCheckingWindow.jobs
        jobKeys = jobs && jobs.length > 0 ? Array.from(jobs, p => p.uuid) : []
      } else {
        jobKeys = this.$refs.batchCheckingWindow.checkPassKeys
        this.$logger.log('预提交——jobKeys：', jobKeys)
      }
      if (jobKeys && jobKeys.length > 0) {
        const officeId = this.$store.getters.currentOfficeId
        batchPreCommit({ jobKeys, officeId, location: this.location }).then(res => this.handlerPreCommitResult(res))
      }
    },
    // 批量预提交处理结果
    handlerPreCommitResult(res) {
      const list = res.data
      const len = (list === null || list === '') ? 0 : list.length
      this.$message.success(this.$t('Message.BatchSubmittedPreSuccessfully') + ': ' + len)
      this.onCallback()
    },
    //  验证规则配置公用
    checkingManager(jobs, checkNode, callBack, callBack2, allowPartialCheckPass = false) {
      if (jobs && jobs.length > 0) { // 批量验证
        this.batchCheckingWindow.checkNode = checkNode
        this.batchCheckingWindow.jobs = jobs
        this.batchCheckingWindow.allowPartialCheckPass = allowPartialCheckPass
        this.batchCheckingWindow.callBack = callBack
        this.batchCheckingWindow.callBack2 = callBack2
        this.batchCheckingWindow.visible = true
      }
    },
    // 批量提交
    async toBatchSubmit() {
      let jobKeys = []
      let selectedJobs = []
      const allowBatchSubmitJobState = cache.config.get('AllowBatchSubmitJobState')
      const allowBatchSubmitJobStateArr = allowBatchSubmitJobState ? allowBatchSubmitJobState.split(',') : []
      const operateStr = SystemConstants.OPERATING.toString()
      const preCommitStr = SystemConstants.PRE_COMMIT.toString()
      const len = allowBatchSubmitJobStateArr.length
      const paramsBpm = []
      for (const item of this.jobs) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (len > 1 && allowBatchSubmitJobStateArr.includes(operateStr) && allowBatchSubmitJobStateArr.includes(preCommitStr) && !(Number(item.jobState) === SystemConstants.OPERATING || Number(item.jobState) === SystemConstants.PRE_COMMIT)) {
          this.$message.warning(this.$t('Message.BatchSubmitCheck'))
          return
        }
        if (len === 1 && allowBatchSubmitJobStateArr.includes(operateStr) && !(Number(item.jobState) === SystemConstants.OPERATING)) {
          this.$message.warning(this.$t('SeaExport.BatchSubmitCheckOperate'))
          return
        }
        if (len === 1 && allowBatchSubmitJobStateArr.includes(preCommitStr) && !(Number(item.jobState) === SystemConstants.PRE_COMMIT)) {
          this.$message.warning(this.$t('SeaExport.BatchSubmitCheckPre'))
          return
        }
        if (!item.masterFlag && !item.lclMasterUuid && (item.containerLoadType === 'LCL' || item.containerLoadType === 'BC') && this.ticketsMustBeVoted) {
          this.$message.info(this.$t('Message.TicketsMustBeVoted'))
          return
        }
        jobKeys.push(item.uuid)
        selectedJobs.push(item)
        // 构建bpm请求参数
        const paramBpm = {
          documentConfigId: Job_CHARGE.code,
          docId: item.uuid,
          docNo: item.jobNo,
          actionType: 7000,
          officeId: item.opOffice,
          applicationDimension: APPLICATION_DIMENSION_JOB_CHARGE.code
        }
        paramsBpm.push(paramBpm)
      }

      if (jobKeys.length > 0) {
        // 预付款余额校验
        const checkFailUuids = []
        const continueExec = await JobUtils.checkBalanceBeforeSubmitHandler(jobKeys, checkFailUuids, true)
        if (!continueExec) {
          return
        }
        // 余额不足
        if (checkFailUuids && checkFailUuids.length > 0) {
          const checkKeys = []
          for (const key of jobKeys) {
            if (checkFailUuids.indexOf(key) === -1) {
              checkKeys.push(key)
            }
          }
          if (checkKeys.length > 0) {
            jobKeys = checkKeys
            selectedJobs = []
            for (const item of this.jobs) {
              if (jobKeys.indexOf(item.uuid) !== -1) {
                selectedJobs.push(item)
              }
            }
          } else {
            return
          }
        }
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_COMMIT.code
        if (this.useCheckRule) {
          const hasCheckRule = await JobUtils.hasConfigCheckRuleByJobs(checkNode, jobKeys, this.job.lob)
          if (hasCheckRule) {
            this.batchCheckingWindow.jobs = selectedJobs // 回调中使用
            this.paramsBpm = paramsBpm
            this.opOffice = selectedJobs[0].opOffice
            if (this.allowPartialCheckPass) {
              const callBack = this.batchCommitCall || null
              this.checkingManager(selectedJobs, checkNode, callBack, null, true)
            } else {
              const callBack = this.batchCommitCall || null
              this.checkingManager(selectedJobs, checkNode, callBack, null, false)
            }
          } else {
            if (await WorkflowUtil.isBpmEnabled({ documentConfigId: Job_CHARGE.code, officeId: selectedJobs[0].opOffice })) {
              WorkflowUtil.jobBatchCommitBpm(this, paramsBpm)
              return
            }
            batchCommit({ jobKeys, officeId: this.$store.getters.currentOfficeId, location: this.location }).then(res => this.handlerCommitResult(res))
          }
        } else {
          this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + jobKeys.length + this.$t('SeaExport.VotesSubmission'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning',
            closeOnClickModal: false
          }).then(async() => {
            const officeId = this.$store.getters.currentOfficeId
            if (await WorkflowUtil.isBpmEnabled({
              documentConfigId: Job_CHARGE.code,
              officeId: selectedJobs[0].opOffice
            })) {
              WorkflowUtil.jobBatchCommitBpm(this, paramsBpm)
              return
            }
            batchCommit({ jobKeys: jobKeys, officeId: officeId, location: this.location }).then(res => this.handlerCommitResult(res))
          }).catch(() => {
          })
        }
      }
    },
    // 批量提交回调
    async batchCommitCall() {
      let jobKeys = []
      if (!this.allowPartialCheckPass) {
        const jobs = this.batchCheckingWindow.jobs
        jobKeys = jobs && jobs.length > 0 ? Array.from(jobs, p => p.uuid) : []
      } else {
        this.$logger.log('提交——jobKeys：', jobKeys)
        jobKeys = this.$refs.batchCheckingWindow.checkPassKeys
      }
      if (jobKeys && jobKeys.length > 0) {
        // 过滤有效keys
        this.paramsBpm = this.paramsBpm.filter(paramBpm => jobKeys.indexOf(paramBpm.docId) !== -1)
        if (await WorkflowUtil.isBpmEnabled({ documentConfigId: Job_CHARGE.code, officeId: this.opOffice })) {
          WorkflowUtil.jobBatchCommitBpm(this, this.paramsBpm)
          return
        }
        const officeId = this.$store.getters.currentOfficeId
        batchCommit({ jobKeys: jobKeys, officeId: officeId, location: this.location }).then(res => this.handlerCommitResult(res))
      }
    },
    // 批量提交处理结果
    handlerCommitResult(res) {
      const list = res.data
      const len = (list === null || list === '') ? 0 : list.length
      this.$message.success(this.$t('Message.BatchSubmittedSuccessfully') + ': ' + len)
      this.onCallback()
    },
    // 批量主管提交
    async toBatchManagerSubmission() {
      let rows = []
      let jobKeys = []
      for (const j of this.jobs) {
        if (this.isCooperate(j.cooperateStatus)) {
          this.$message.warning('[' + j.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!this.allowPartialCheckPass) {
          if (Number(j.jobState) !== Number(SystemConstants.OPERATING) && Number(j.jobState) !== Number(SystemConstants.PRE_COMMIT)) {
            this.$message.warning(this.$t('SeaExport.BatchManagerSubmissionTips'))
            return
          }
          if (!j.masterFlag && !j.lclMasterUuid && (j.containerLoadType === 'LCL' || j.containerLoadType === 'BC') && this.ticketsMustBeVoted) {
            this.$message.warning(this.$t('Message.TicketsMustBeVoted'))
            return
          }
        }
        jobKeys.push(j.uuid)
        rows.push(j)
      }
      if (jobKeys.length > 0) {
        // 预付款余额校验
        const checkFailUuids = []
        const continueExec = await JobUtils.checkBalanceBeforeSubmitHandler(jobKeys, checkFailUuids, true)
        if (!continueExec) {
          return
        }
        // 余额不足
        if (checkFailUuids && checkFailUuids.length > 0) {
          const checkKeys = []
          for (const key of jobKeys) {
            if (checkFailUuids.indexOf(key) === -1) {
              checkKeys.push(key)
            }
          }
          if (checkKeys.length > 0) {
            jobKeys = checkKeys
            rows = []
            for (const j of selectedRows) {
              if (jobKeys.indexOf(j.uuid) !== -1) {
                rows.push(j)
              }
            }
          } else {
            return
          }
        }
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_MANAGER_COMMIT.code
        if (this.useCheckRule) {
          const hasCheckRule = await JobUtils.hasConfigCheckRuleByJobs(checkNode, jobKeys, rows[0].lob)
          if (hasCheckRule) {
            this.batchCheckingWindow.jobs = rows // 回调中使用
            const callBack = this.batchBatchManagerSubmissionCall || null
            this.checkingManager(rows, checkNode, callBack, null, this.allowPartialCheckPass)
          } else {
            batchManagerCommit({ jobKeys, officeId: this.$store.getters.currentOfficeId, location: this.location }).then(res => this.handlerBatchManagerSubmissionResult(res))
          }
        } else {
          this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + jobKeys.length + this.$t('SeaExport.VotesManagerSubmission'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {
            batchManagerCommit({
              jobKeys: jobKeys,
              officeId: this.$store.getters.currentOfficeId,
              location: this.location
            }).then(res => this.handlerBatchManagerSubmissionResult(res))
          }).catch(() => {})
        }
      }
    },
    batchBatchManagerSubmissionCall() {
      let jobKeys = []
      if (!this.allowPartialCheckPass) {
        const jobs = this.batchCheckingWindow.jobs
        jobKeys = jobs && jobs.length > 0 ? Array.from(jobs, p => p.uuid) : []
      } else {
        jobKeys = this.$refs.batchCheckingWindow.checkPassKeys
      }
      if (jobKeys && jobKeys.length > 0) {
        batchManagerCommit({
          jobKeys,
          officeId: this.$store.getters.currentOfficeId,
          location: this.location
        }).then(res => this.handlerBatchManagerSubmissionResult(res))
      }
    },
    // 批量主管提交处理结果
    handlerBatchManagerSubmissionResult(res) {
      const len = res.data ? res.data.length : 0
      this.$message.success(this.$t('SeaExport.BatchManagerSubmissionSuccessfully') + len)
      this.onCallback()
    },
    // 批量审核
    async batchAuditClickHandler() {
      await Assert.isTrue(this.jobs.length > 0, this.$t('CargoMsg.Cargo_PleaseSelectBusiness'), 'warning')
      if (this.jobAndChargeSubmitterAndAuditorCanNotSame) {
        for (const job of this.jobs) {
          if (job.commitUser === this.$store.getters.userId) {
            this.$message.warning(this.$t('FinanceManage.SelectedDataJobSubmitNotAllowAudit'))
            return
          }
        }
      }
      for (const job of this.jobs) {
        if (this.isCooperate(job.cooperateStatus)) {
          this.$message.warning('[' + job.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        const jobState = CommonState.getStateByCode(SystemConstants.JOB_STATES, job.jobState)
        if (this.isAuditByJobState) {
          if (Number(job.jobState) !== 1) {
            const isZh = this.$store.getters.language === 'zh'
            this.$message.warning(this.$t('CargoMsg.Cargo_CAN_NOT_APPROVED', [isZh ? jobState.chineseName : jobState.englishName]))
            return
          }
        } else {
          if (!(Number(job.jobState) === 0 || Number(job.jobState) === 11 || Number(job.jobState) === 1)) {
            const isZh = this.$store.getters.language === 'zh'
            this.$message.warning(this.$t('CargoMsg.Cargo_CAN_NOT_APPROVED', [isZh ? jobState.chineseName : jobState.englishName]))
            return
          }
        }
      }
      // 判断是否开启验证规则
      const opOffice = (this.jobs && this.jobs.length > 0) ? this.jobs[0].opOffice : 0
      const hasCheckRule = await JobUtils.hasCheckRuleCondition(this.useCheckRule, 13, opOffice)
      if (this.useCheckRule && hasCheckRule) {
        this.batchAuditDialog.isEditable = false
        this.batchAuditDialog.visible = false
        const callBack = () => {
          this.batchAuditDialog.isEditable = true
          this.batchAuditDialog.visible = true
        }
        this.checkingManager(this.jobs, 13, callBack, null, false)
      } else {
        this.batchAuditDialog.isEditable = true
        this.batchAuditDialog.visible = true
      }
    },
    async batchAuditConfirmCB({ accountDate, poNo }) {
      const jobKeys = this.jobs.map(job => job.uuid)
      this.batchAuditDialog.adjustPageDate = new Date(accountDate)
      await this.checkAccountDate(accountDate)
      let operateNameCode = SystemConstants.OPERATE_BATCH_AUDIT.code
      const branchId = this.$store.getters.currentOfficeId
      let func = jobAccountVerify
      if (this.jobs.length === 1) {
        func = jobSingleAccountVerify
        operateNameCode = SystemConstants.OPERATE_AUDIT.code
      }
      const loading = getLoading4Cxt(this.$refs.batchAuditDialog)
      await func({ operateNameCode, jobKeys, accountingDate: accountDate, allSubmitFcl: this.allSubmitFcl, poNo, branchId, location: this.location }).then(res => {
        if (this.openHecConfig) {
          this.commitSapResultHandler(jobKeys, res.data)
        } else {
          this.onCallback()
          this.batchAuditConfirmSuccessCB(res.data)
        }
      }).catch(err => {
        this.batchAuditConfirmFailCB()
      }).finally(() => {
        loading.close()
        this.batchAuditDialog.visible = false
      })
    },
    // 核对审核日期
    async checkAccountDate(accountDate) {
      let check = false
      for (const job of this.jobs) {
        if (new Date(job.businessDate) > accountDate) {
          check = true
          break
        }
      }
      await this.$confirm(check ? this.$t('Message.TheApprovalDateIsEarlierThanTheBusinessDate') : this.$t('CargoMsg.Cargo_SureToReviewTheBills'), this.$t('CargoMsg.Cargo_Tips'), { type: 'warning' })
    },
    async commitSapResultHandler(jobKeys, data) {
      await sendHecMessageByFinance(jobKeys, ChargeUtils.CHARGE_SH.code).then(res => {
        this.sendSapMessageSuccess(res, data)
      }).catch((err) => {
        this.failureHandler(err)
      })
    },
    sendSapMessageSuccess(res, data) {
      let r = 'failure'
      if (res && Number(res.data) > 0) {
        r = 'success'
        this.$message.success(this.$t('Message.SapSynchronizationSuccess'))
      } else {
        this.$message.error(this.$t('Message.SapSynchronizationFault'))
      }
      this.onCallback()
      this.batchAuditConfirmSuccessCB(data)
    },
    batchAuditConfirmSuccessCB(res) {
      if (res === 'ok') {
        this.$message.success(this.$t('FinanceManage.AccountVerifyBusinessSuccess'))
      } else if (res === 'repeatClick') {
        this.$message.warning(this.$t('Message.RepeatClickJobAccountVerify'))
      } else if (res === 'asyncDo') {
        this.$message.success(this.$t('Message.AsynchronousJobAccountVerify'))
      } else {
        this.$message.success(this.$t('SeaExport.BatchAuditSuccess'))
      }
    },
    failureHandler(err) {
      this.$message(this.$t('Clearing.FrontEndErrorCallbackFailed') + err)
    },
    async batchAuditConfirmFailCB() {
      this.$message.warning(this.$t('Message.BatchApprovalFailed'))
    },
    onCallback() {
      const loading = getLoading4Cxt(this)
      generateInstructionRecord({ jobUuids: this.jobs.map(job => job.uuid), executeStatus: true, instructionUuid: this.tenantInstruction.uuid }).then(res => {
        this.$emit('instructionCallback')
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>
